import { gql } from 'graphql-tag'

export const CHECK_DATA_HEALTH_STATUS_QUERY = gql`
  query CHECK_DATA_HEALTH_STATUS_QUERY($check: GetDataHealthCheckInputDto!) {
    getDataHealthCheckStatus(check: $check) {
      status
    }
  }
`
